import { AIAssistedHeader } from './AIAssistedHeader'
export default AIAssistedHeader
